import KitText from '@omni/kit/components/KitText';
import React, { ReactElement, useEffect } from 'react';
import { Platform, View } from 'react-native';

import { AuthService } from './Service/index';

interface IProps {
  authProviderId: string;
  redirectUrl: string;
  token?: string;
  reloadPage?: boolean;
}

// Utility function to get query parameters from window.location (works in both React Router and React Navigation)
const getWebQueryParams = () => {
  if (typeof window !== 'undefined' && window.location) {
    const urlSearchParams = new URLSearchParams(window.location.search);

    return {
      access_token: urlSearchParams.get('access_token'),
      sap_token: urlSearchParams.get('sap_token'),
    };
  }

  return {};
};

// Utility function to navigate (works in both React Router and React Navigation)
const navigateToUrl = (url: string) => {
  if (typeof window !== 'undefined') {
    window.location.href = url;
  }
};

export default ({
  authProviderId,
  redirectUrl,
  token,
  reloadPage,
}: IProps): ReactElement => {
  useEffect(() => {
    // Get query parameters from window.location (works in both contexts)
    const webQueryParams = getWebQueryParams();
    const accessToken = webQueryParams.access_token;
    const refreshToken = webQueryParams.sap_token;
    const finalToken = token || accessToken;

    AuthService.setAccessToken(
      authProviderId,
      finalToken?.replace('Bearer ', '') || null
    );

    if (refreshToken) {
      AuthService.refreshToken = refreshToken;
    }

    AuthService.notifyAuthorizationChanged();

    // Navigate using window.location (works in both React Router and React Navigation)
    navigateToUrl(redirectUrl);

    if (Platform.OS === 'web' && window.opener) {
      const parentWindow = window.opener;
      let shouldReloadPage = reloadPage;

      try {
        // Test if we can access the parent window
        const hasReloadAuth = parentWindow.reloadAuth;

        if (!hasReloadAuth) {
          shouldReloadPage = true;
        }

        if (hasReloadAuth && !shouldReloadPage) {
          parentWindow.reloadAuth({ accessToken: finalToken, refreshToken });
        } else {
          parentWindow.location.reload();
        }
      } catch (error) {
        try {
          parentWindow.location.reload();
        } catch (reloadError) {
          // Silently fail if we can't reload parent window
        }
      }

      window.close();
    }
  }, [authProviderId, redirectUrl, token, reloadPage]);

  return (
    <View>
      <KitText>Redirecting..</KitText>
    </View>
  );
};
